// Ported from v2 MMM-React/src/util/date.js + reorganised post-Task-1 review.
// `parseDateLocal` was previously duplicated in Charts/dataPipeline.ts; the
// natural home for date utilities is here. dataPipeline now imports from here.
// All formatters are TZ-stable: they read local-calendar components from a
// `Date` constructed via `(y, m-1, d)`, which is independent of host timezone.

export function parseDateLocal(iso: string): Date {
  const parts = iso.slice(0, 10).split('-').map(Number)
  const [y, m, d] = parts
  return new Date(y!, m! - 1, d!)
}

function pad2(n: number): string {
  return String(n).padStart(2, '0')
}

export function toLongDate(date: string | Date): string {
  const d = typeof date === 'string' ? parseDateLocal(date) : date
  return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()}`
}

export function toShortDate(date: string | Date): string {
  const d = typeof date === 'string' ? parseDateLocal(date) : date
  return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}`
}

/** Wave-3 §3: uniform short x-ticks (dd-MM); year context lives in the timeframe
 *  controls / pin caption. Replaces dateTickFormatter's long-form edge ticks, which
 *  collided with their neighbors at 4-8 panel layouts. */
export function shortDateTick(v: string | number): string {
  if (v === 0 || v === 'auto') return ''
  return toShortDate(String(v))
}
